var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch } from 'vue-property-decorator';
import Widget from '../Widget';
import Chart from 'chart.js';
var ChartWidget = /** @class */ (function (_super) {
    __extends(ChartWidget, _super);
    function ChartWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.chart_data = null;
        return _this;
    }
    ChartWidget.prototype.renderChart = function (chartData) {
        if (!this.current_chart) {
            var chartCanvas = this.$el.querySelector('canvas');
            this.current_chart = new Chart(chartCanvas, {
                type: chartData.type,
                data: chartData.data,
                options: chartData.options || {}
            });
        }
        else {
            this.current_chart.data = chartData.data;
            this.current_chart.update();
        }
    };
    ChartWidget.prototype.onChartDataChanged = function (newData, oldData) {
        this.renderChart(newData);
    };
    __decorate([
        Watch('chart_data')
    ], ChartWidget.prototype, "onChartDataChanged", null);
    ChartWidget = __decorate([
        Component
    ], ChartWidget);
    return ChartWidget;
}(Widget));
export default ChartWidget;
